import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { style } from '@angular/animations';

@Component({
  selector: 'app-calender',
  templateUrl: './calender.component.html',
  styleUrls: ['./calender.component.css']
})
export class CalenderComponent implements OnInit {

  @Input() label: String;
  @Input() model:any;
  @Input() style:any;
  @Input() minDateValue:any;
  @Input() maxDateValue:any;
  @Output() dateRange = new EventEmitter<string>();

  constructor() { }
  modelChange($event) {
    this.dateRange.emit($event);
  }
  ngOnInit() {
  }
}